/* eslint-disable react-hooks/exhaustive-deps */
import { useThree } from '@react-three/fiber';
import React, { useEffect } from 'react';
import { Material, Mesh, Scene, Texture } from 'three';

const disposeMaterial = (material: Material) => {
	// Dispose textures
	for (const key in material) {
		const value = material[key as keyof typeof material];
		if (value && (value as Texture).isTexture) {
			(value as Texture).dispose();
		}
	}
	material.dispose();
};

const disposeScene = (scene: Scene) => {
	scene.traverse((m) => {
		// Dispose geometries
		const mesh = m as Mesh;
		if (mesh.geometry) {
			mesh.geometry.dispose();
		}

		// Dispose materials and associated textures
		if (mesh.material) {
			// Handle multi-materials
			if (Array.isArray(mesh.material)) {
				mesh.material.forEach(disposeMaterial);
			} else {
				disposeMaterial(mesh.material);
			}
		}
	});

	// Remove all children
	while (scene.children.length > 0) {
		scene.remove(scene.children[0]);
	}
}

const CanvasCleanupOnUnmount: React.FunctionComponent = () => {
	const { gl, scene } = useThree();

	useEffect(() => {
		return () => {
            disposeScene(scene);
			gl.forceContextLoss?.();
			gl.dispose?.();
		};
	}, []);

	return null;
};
export default CanvasCleanupOnUnmount;
